import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterContentsRoutes {
  index() {
    return Ziggy
      .route('writer.contents.index')
      .toString()
  }

  fetchItems() {
    return Ziggy
      .route('writer.contents.fetch_items')
      .toString()
  }

  show() {
    return Ziggy
      .route('writer.contents.show')
      .toString()
  }

  download() {
    return Ziggy
      .route('writer.contents.download')
      .toString()
  }

  showContent() {
    return Ziggy
      .route('writer.contents.show_content')
      .toString()
  }

  saveContentDraft() {
    return Ziggy
      .route('writer.contents.save_content_draft')
      .toString()
  }

  saveContent() {
    return Ziggy
      .route('writer.contents.save_content')
      .toString()
  }
}
